import AssignmentBadge from './assignment_badge';
import AssignmentBadgeV2 from './assignment_badge/v2';
import PriorityBadge from './priority_badge';
import StatusBadge from './status_badge';
import TableStatusBadge from './table_status_badge';
import { TableStatusBadgeInProgress } from './table_status_badge_in_progress';
import TaskBadge from './task_badge';

export {
  AssignmentBadge,
  AssignmentBadgeV2,
  PriorityBadge,
  StatusBadge,
  TableStatusBadge,
  TableStatusBadgeInProgress,
  TaskBadge,
};
